import { useCallback } from 'react';
import { NotificationType } from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { useVoicemailTagNotification } from '@frontend/notifications';
import { useQueueStore } from '@frontend/queue';
import { GetWebsocketEventHandler, useWebsocketEventSubscription } from '@frontend/websocket';

export const useWebsocketVoicemailTagEventSubscription = () => {
  const { enqueue } = useQueueStore();

  const { create: createNotification } = useVoicemailTagNotification({
    onView: async (event) => {
      const { payload: params } = event;
      enqueue('voicemail-details', {
        payload: {
          type: 'query-then-open-detached',
          voicemailId: params.voicemailMessageId,
          locationId: params.locationId,
        },
      });
    },
  });

  const eventHandler = useCallback<GetWebsocketEventHandler<NotificationType.VOICEMAIL_TAG>>(
    (event) => {
      const { params } = event;

      createNotification({
        id: event.id,
        timestamp: Date.now(),
        type: 'voicemail-tag',
        payload: params,
        state: {
          paused: false,
          status: 'unread',
        },
      });
    },
    [createNotification]
  );
  return useWebsocketEventSubscription(NotificationType.VOICEMAIL_TAG, eventHandler);
};
